import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pointLabel',
  standalone: false,
})
export class PointLabelPipe implements PipeTransform {
  transform(pointName: string | null | undefined): string {
    if (!pointName) {
      return '';
    }

    const idx = pointName.indexOf('(');

    if (idx <= 0 || !pointName.endsWith(')')) {
      return pointName;
    }

    const label = pointName.slice(idx + 1, -1).trim();

    return label;
  }
}
